export default __webpack_public_path__ + "static/media/logo-green.4e4b2d6a.svg";